import config from "../branding/default/js/config";
import ActionTypes from "../actions/actionTypes";

export const isKiosk = state => state.config.mode.kiosk;

const initialState = {
  ...config,
  config_loading: true,
  init: false,
  audio: true,
  video: false,
  webrtc: true,
  temasys: false,
  system: {},
  localStream: null,
  localIp: null,
};

const configReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.LOCAL_IP_AQUIRED:
      state = {
        ...state,
        localIp: action.ip,
      };
      break;
    case ActionTypes.WEBRTC_DETECTED:
      state = {
        ...state,
        init: false,
        webrtc: action.payload.webrtc,
        temasys: action.payload.temasys,
      };
      break;
    case ActionTypes.CONFIG_INIT_COMPLETED:
      state = {
        ...state,
        init: true,
      };
      break;
    case ActionTypes.CONFIG_REQUIREMEDIA_SUCCESS:
    case ActionTypes.CONFIG_REQUIREMEDIA_STARTED:
    case ActionTypes.CONFIG_REQUIREMEDIA_FAILURE:
      state = {
        ...state,
        audio: action.payload.audio,
        video: action.payload.video,
      };
      break;
    case ActionTypes.BIND_LOCAL_STREAM:
      state = {
        ...state,
        localStream: action.payload.stream,
      };
      break;
    case ActionTypes.UNBIND_LOCAL_STREAM:
      state = {
        ...state,
        localStream: null,
      };
      break;
    case ActionTypes.CONFIG_SYSTEM_LOADED:
      state = {
        ...state,
        config_loading: false,
        system: {
          ...state.system,
          ...action.payload.systemConfig,
        },
      };
      break;
    case ActionTypes.CONFIG_SYSTEM_LOADING:
      state = {
        ...state,
        config_loading: true,
      };
      break;
    case ActionTypes.CONFIG_DEBUG_ENABLE:
      state.mode.debug_enabled = true;
      state.mode.debug_enabled_in_menu = true;
      window.logenabled = true;
      break;
    case ActionTypes.UNSUPPORTED_BROWSER:
      state = {
        ...state,
        unsupportedBrowser: action.payload,
      };
      break;

    default:
      break;
  }
  return state;
};

export default configReducer;






// WEBPACK FOOTER //
// ./src/reducers/configReducer.js